import { render, staticRenderFns } from "./VueGoodTablePagination.vue?vue&type=template&id=40e15cc7&"
import script from "./VueGoodTablePagination.vue?vue&type=script&lang=js&"
export * from "./VueGoodTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports